import { useState, useEffect } from 'react';


function WLTable({ sportcode, teams, opps, seasons, location, teamid }) {

    const [wlData, setWlData] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        
        async function fetchData() {
            const wlSummary = await fetch(`/${sportcode}/WinLossSummary`, {
                method: 'POST', 
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    TeamIds: teams,
                    OppIds: opps,
                    SeasonIds: seasons,
                    Location: location
                })
            });
            const result = await wlSummary.json();

            //console.log("WlTableGames", result)

            setWlData(result);
            setLoading(false);
        }

        fetchData();
    }, [teams, opps, seasons, location]);



    return (

            loading ?(<span> Loading...</span >) : (

                 <table className="table text-center">
            <thead>
                <tr>
                    <th scope="col">Game Result</th>
                    <th scope="col">Games</th>
                    <th scope="col">Avg Score Diff</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                        <th scope="row" className="bg-danger text-white">WIN</th>
                        <td>{wlData ? wlData.GamesWin : ''}</td>
                        <td>{wlData ? (Math.round(wlData.ScoreDiffWin * 100)/100) : ''}</td>
                </tr>
                <tr>
                        <th scope="row" className="table-secondary">LOSS</th>
                        <td>{wlData ? wlData.GamesLoss : ''}</td>
                        <td>{wlData ? (wlData.ScoreDiffLoss ? (wlData.ScoreDiffLoss * -1.0) : 0.0) : ''}</td>
                </tr>
                <tr className="table-secondary">
                    <th scope="row" className="bg-primary text-white">ALL</th>
                        <td>{wlData ? ((wlData.GamesWin ?? 0) + (wlData.GamesLoss ?? 0)) : ''}</td>
                        <td>{wlData ? Math.round(((wlData.ScoreDiffWin ?? 0) - (wlData.ScoreDiffLoss ?? 0)) * 100) / 100  : ''}</td>
                </tr>
            </tbody>
        </table>

            )
    
    );
}

export default WLTable;